module.exports = __webpack_public_path__ + "images/emoji/strawberry.65520981a1389c4573d4.png";